var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { CaseStatus } from '@debbie/common/dist/cases';
import { UpdateState } from '@debbie/common/dist/updates';
import { TodoType } from '@debbie/common/dist/workflows';
import { c, h } from '@debbie/cortex/dist';
import * as insightsAPI from '@debbie/cortex/dist/api/insights';
import THEME from '../../theme';
import { Row } from '../Grid';
import { CornerDownRight } from '../Icons';
import ExternalLink from '../Icons/ExternalLink';
import Info from '../Icons/Info';
import Pause from '../Icons/Pause';
import Play from '../Icons/Play';
import Trash2 from '../Icons/Trash2';
import Zap from '../Icons/Zap';
import Loading from '../Loading';
import UserType from '../UserType';
import Procedure from './Procedure';
import { useWorkflowStats } from '@debbie/cortex/dist/workflows';
const style = {
    color: THEME.COLOR_ACCENT,
    margin: '0.15em 0 -0.15em',
};
const UpdateType = (props) => {
    var _a, _b, _c, _d, _e;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const statsLoadable = useWorkflowStats(!props.caseContext ? props.workflowId || null : null, {});
    const stats = h.hasData(statsLoadable) ? statsLoadable.data : null;
    const [redirecting, setRedirecting] = useState(false);
    const { onDelete, updateType, task } = props;
    const executedUpdate = props.caseContext &&
        props.caseContext.updates.find((update) => update.state === UpdateState.Executed && update.taskId === (task === null || task === void 0 ? void 0 : task.id));
    const taskStats = stats &&
        (task === null || task === void 0 ? void 0 : task.id) &&
        stats.tasks.find((taskStats) => taskStats.taskId === (task === null || task === void 0 ? void 0 : task.id));
    const endedCasesQty = taskStats
        ? taskStats.endedCases.reduce((acc, reason) => reason.count + acc, 0)
        : 0;
    const goToCases = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!redirecting) {
            if (task) {
                setRedirecting(true);
                const caseQueue = yield insightsAPI.getCaseFilterQueue({
                    currentTaskIds: [task.id],
                    caseStatuses: [CaseStatus.VERIFIED],
                });
                setRedirecting(false);
                c.redirect.redirect(`/cases/${caseQueue.join(',')}`);
            }
        }
    });
    return (React.createElement(UpdateTypeStyled, { disabled: props.caseContext && !props.isPossibleTask, onClick: (e) => {
            if (!props.isPossibleTask)
                e.preventDefault();
        } },
        executedUpdate && (React.createElement("h4", { style: {
                color: THEME.COLOR_ACCENT,
                marginTop: '0.5em',
            } }, moment(executedUpdate.pausedAt).format(THEME.DATE_FORMAT_LONG))),
        React.createElement("h3", null,
            updateType.procedureEnabled ? (React.createElement(Zap, { style: Object.assign(Object.assign({}, style), (executedUpdate
                    ? {}
                    : {
                        color: THEME.COLOR_PRIMARY,
                    })) })) : ((_b = (_a = task === null || task === void 0 ? void 0 : task.pauseAtTiming) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.timespan[0]) === 0 ? (React.createElement(Play, { style: style })) : updateType.pausing ? (React.createElement(Pause, { style: style })) : (React.createElement(Info, { style: style })),
            ' ',
            lang.updateTypes[updateType.updateTypeId] || updateType.label,
            ' ',
            onDelete && !props.caseContext && Site.Caseworker === site && (React.createElement(Trash2, { style: {
                    color: THEME.COLOR_ACCENT,
                    float: 'right',
                    cursor: 'pointer',
                }, onClick: () => props.task && confirm(lang.workflows.sureYouWantToDeleteTask)
                    ? onDelete(props.task.id)
                    : null })),
            !updateType.public && Site.Caseworker === site && (React.createElement(ExternalLink, { style: {
                    float: 'right',
                    cursor: 'pointer',
                    marginRight: '5px',
                }, onClick: () => c.redirect.redirect(`/settings/workflows/tasks/${updateType.updateTypeId}`) }))),
        taskStats && (React.createElement("p", { style: {
                marginTop: '-9px',
                fontWeight: 900,
            } },
            taskStats.currentTaskCases,
            ' ',
            React.createElement("span", { style: { opacity: 0.7 } }, lang.workflows.casesInTask),
            ' ',
            !!taskStats.currentTaskCases &&
                (redirecting ? (React.createElement(Loading, { style: {
                        width: '15px',
                        margin: '0px 1px -4px 1px',
                    } })) : (React.createElement(ExternalLink, { style: { cursor: 'pointer' }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        goToCases();
                    }) }))))),
        React.createElement("p", null,
            updateType.groupLabel,
            ' ',
            updateType.responsiblePermissionLevel &&
                !updateType.procedureEnabled &&
                ((_d = (_c = task === null || task === void 0 ? void 0 : task.pauseAtTiming) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.timespan[0]) !== 0 && (React.createElement(UserType, { role: updateType.responsiblePermissionLevel },
                lang.roles[updateType.responsiblePermissionLevel],
                ' '))),
        updateType.procedure && updateType.procedureEnabled && (React.createElement(Procedure, { procedure: updateType.procedure })),
        ((_e = updateType.procedure) === null || _e === void 0 ? void 0 : _e.find((todo) => todo.type === TodoType.ConnectToDebtCollector)) ? (React.createElement(Row, null)) : (taskStats && (React.createElement("p", { style: { marginBottom: '0' } },
            React.createElement(CornerDownRight, { style: { color: THEME.SUCCESS, margin: '0.1em 0 -0.1em 0' } }),
            ' ',
            taskStats.totalCases === 0 || endedCasesQty === 0
                ? 0
                : ((endedCasesQty / taskStats.totalCases) * 100).toFixed(2),
            "% ",
            lang.workflows.endedCasesPercentage)))));
};
export default UpdateType;
const UpdateTypeStyled = styled.div `
  text-align: left;
  user-select: none;

  ${(props) => (props.disabled ? 'opacity: 0.5;' : '')}

  & > h3 {
    font-size: 14px;
    margin-top: 0.5em;
  }
`;
//# sourceMappingURL=UpdateType.js.map